// Gedeelde component voor de reschedule-indicator (dots).
// Vervangt duplicatie tussen TaskMetadata en TaskTitleSection.
// @ts-check

const DOTS_KEYS = ['dot-1', 'dot-2', 'dot-3', 'dot-4', 'dot-5'];

/**
 * Toont een reeks stippen die aangeven hoe vaak een taak is verzet.
 * @param {{ count?: number }} props
 */
const RescheduleIndicator = ({ count }) => {
  if (!count || count <= 2) return null;
  const dots = Math.min(count, 5);
  const isError = count >= 5;

  return (
    <span
      className={`reschedule-indicator ${isError ? 'reschedule-error' : 'reschedule-warning'}`}
      title={`Deze taak is ${count} keer verzet.`}
    >
      {DOTS_KEYS.slice(0, dots).map((key) => (
        <span key={key} className="reschedule-dot" />
      ))}
      {count > 5 ? <span className="reschedule-plus">+</span> : null}
    </span>
  );
};

export default RescheduleIndicator;
